module.exports = __webpack_public_path__ + "media/images/design/images/event_search/btn_eventclendar-922d9339ecdc6ba734a6c3af0d310e32.jpg";